import axios from 'axios';
import { getCookie } from '@/utils/cookies';
import store from '@/store';
import { FEATURENAME, POPUP } from '@/enum/enum';
import { uuid } from 'vue-uuid';
import { router } from '@/router';
import * as moment from 'moment';
import { dateTimeHandle } from '@/utils/time';
import i18n from '@/locales/i18n';


const env = process.env.NODE_ENV;
console.log('env', env);

let host = '';
let token = ''
let globalApiReq = null;
// let globalData = null;
let csrfToken = null;
let subURL = 'api/v1/';
let subURL2 = 'api/v2/';

// const corsURL = 'https://cors-anywhere.herokuapp.com/'

//url 
const device = `${subURL}devices`;
const group = `${subURL}groups`;
const dashboard = `${subURL}dashboards`;
const notifications = `${subURL}notifications`;
const settings = `${subURL2}query-settings`;
const deleteGroup = `/${subURL}delete-groups`;
const deleteDevice = `/${subURL}unbind-devices`;
const deleteTask = `/${subURL}delete-tasks`;
const deleteAppointment = `/${subURL}delete-appointments`;
const calibration = `${subURL2}query-settings`;
const tasks = `${subURL}tasks`;
const delete_notification = `/${subURL}delete-notifications`;
const approve_notification = `/${subURL}approve-notifications`;
const getGroupModel = `/${subURL}outline`;
const targets = `${subURL}targets`;
const feedback = `${subURL}feedbacks`;
const invitations = `${subURL}invitations`;
const csv = `${subURL}export-csv`;
const appointments = `${subURL2}appointments`;
const appointmentAll = `${subURL}appointments`;
const modifyAppointments = `${subURL2}modify-appointments`
const me = `${subURL}me`;
const delTarget = `${subURL}delete-targets`;
const importTarget = `${subURL}import-targets`;
const exportTarget = `${subURL}export-targets`;
const csvs = `${subURL}csvs`;
const loginURL = `${subURL}login`;
const logoutURL = `${subURL}logout`;
const ws = `${subURL}wss`;
const policy = `${subURL}policy-agreements`;
const webEvent = `${subURL}web-events`;
const eula = `${subURL}eula`;
const newNotifications = `${subURL}new-notifications-count`;
const appointmentTask = `${subURL}appointment-tasks`;


export const getNewCSRFToken = async () => {
    host = window.location.origin + '/';
    await axios.get(host + 'sanctum/csrf-cookie', { withCredentials: true });
    console.log('update csrf token');
}

// get csrfToken
export const csrfTokenHandle = async () => {
    host = window.location.origin + '/';
    try {
        csrfToken = getCookie('XSRF-TOKEN');

        globalApiReq = axios.create({
            headers: {
                'X-XSRF-TOKEN': csrfToken
            },
            baseURL: host,
            withCredentials: true
        });

        console.log('apiReq setting', globalApiReq.headers);
        axionInit(globalApiReq, host);

    }
    catch (erro) {
        console.warn(erro, 'error in csrf-cookie')
    }

} //end: csrfTokenHandle



//計算同時打出的API數量以及影響loading持續與否
let showFullScreenLoading = () => {
    if (store.state.apiCount == 0) { //當等於0時證明是第一次請求 這時開啟loading
        store.commit('setIsLoading', true);
    }
    store.commit('setApiCount', 1); //全局變量+++
}
let tryHideFullScreenLoading = () => {
    if (store.state.apiCount <= 0) return //小於等於0 證明沒有開啟loading 此時return
    store.commit('setApiCount', -1); //正常響應後 全局變量--
    if (store.state.apiCount == 0) {  //等於0 時證明全部加載完畢 此時結束loading 加載
        store.commit('setIsLoading', false);
    }

}


// API初始化設定
const apiNoUpdateTimeList = ['export-csv', 'web-events', 'eula', 'wws'];
const axionInit = (axios, base) => {
    axios.defaults.baseURL = base;
    axios.interceptors.request.use((config) => {
        // console.log('api 計算 request',needLoadingRequestCount)
        if (store.state.isNeedAPILoding) {
            showFullScreenLoading()
        }
        return config;
    }, function (error) {
        tryHideFullScreenLoading()
        return Promise.reject(error);
    });
    axios.interceptors.response.use(function (response) {
        // console.log('api 計算 response',needLoadingRequestCount)
        let url = response.config.url;
        let temp = url.split('/');
        let urlItem = temp[temp.length - 1];
        if (!apiNoUpdateTimeList.includes(urlItem)) {
            let time = dateTimeHandle(moment(), '', 'YYYY/MM/DD HH:mm:ss');
            store.commit('setRefreshTime', time);
        }//end: if

        tryHideFullScreenLoading()
        if (response.data) {
            return response.data;
        }
        else {
            return response;
        }


    }, function (error) {
        tryHideFullScreenLoading()
        if (error.response) {
            apiErrorHandle(error.response);
        }
        return Promise.reject(error);
    });

    store.commit('setAPIRequet', axios);
    // console.log('axionInit END')
}


// API ErrorHandle處理
const apiErrorHandle = (res) => {
    console.log('apiErrorHandle', res, router);
    const httpCode = res.status;
    let modalConfig = {
        type: POPUP.APIERROR + uuid.v4(),
        data: {},
        isShow: true,
    }
    console.log('httpCode', httpCode)

    if (httpCode === 401) {
        console.log('no login',);
        // 未登入
        router.push({ name: FEATURENAME.LOGIN })
    }
    else if (res.data) {
        // API 有處理的Error'
        console.log('res.data', res.data)
        const apiURL = res.config.url;
        const apiErrorCode = res.data.status_code
        const apiErrorMsg = res.data.message;
        console.log('apiURL', apiURL)
        console.log('apiErrorCode', apiErrorCode)

        if (apiURL.indexOf('login') != -1) {
            // login api
            if (apiErrorCode == 99) {
                modalConfig.data = i18n.global.t('__popup.__loginFail');
                store.commit('setIsShowModal', modalConfig)
            }// end: if
        }
        else if (apiURL.indexOf('targets') != -1 && apiURL.indexOf('delete-targets') === -1) {
            console.warn('target API Error');
            // delete api 
            if (apiErrorCode == 13) {
                console.warn('target name duplicated');
            }

            else {
                modalConfig.data = `[${apiErrorCode}] ${apiErrorMsg}`;
                store.commit('setIsShowModal', modalConfig)

            }
        }
        else if (apiErrorCode === 16) {
            //csv modal error
            console.warn('csv upload over 300');
            modalConfig = {
                type: POPUP.EXCEED + uuid.v4(),
                data: {},
                isShow: true,
            }
            store.commit('setIsShowModal', modalConfig)
        }
        else if (apiURL === 'api/v1/csvs' && apiErrorCode != 16) {
            //error code 15 && csvs 
            store.commit('setCloseModal');
            const flashMsg = {
                data: i18n.global.t('__flash.__uploadFailed'),
                isShow: true
            }
            setTimeout(() => {
                store.commit('setFlashMsg', flashMsg);

            }, 150)
        }
        else if (apiErrorCode == 2) {
            const flashMsg = {
                data: i18n.global.t('__flash.__deviceNotFound'),
                isShow: true
            }
            setTimeout(() => {
                store.commit('setFlashMsg', flashMsg);

            }, 150)

        }
        else if (apiURL.indexOf('profiles') != -1 && apiErrorCode == 4 || apiURL.indexOf('profiles') != -1 && apiErrorCode == 5) {
            console.log('--- error checkUSB Connected---');
        }
        else {

            console.log('--- error else---');
            modalConfig.data = `[${apiErrorCode}] ${apiErrorMsg}`;
            let txt = apiErrorMsg ? apiErrorMsg : i18n.global.t('__flash.__anUnknownErrorOccurred');
            // store.commit('setIsShowModal', modalConfig)
            const flashMsg = {
                data: `${txt} ${i18n.global.t('__flash.__pleaseTryAgainOrContact')}`,
                isShow: true
            }
            store.commit('setFlashMsg', flashMsg);
        }

    }//end: if (handle api handle error)
    else {
        // API 未處理的Error
        switch (httpCode) {
            case 404:
                modalConfig.data = `[400] ${i18n.global.t('__flash.__canTFindThisApi')}`;
                store.commit('setIsShowModal', modalConfig)
                // go to 404 page
                break;
            case 500:
                modalConfig.data = `[500] ${i18n.global.t('__flash.__thereIsSomeProblemOnServer')}`;
                store.commit('setIsShowModal', modalConfig)
                // go to 500 page
                break;
            default:
                console.log(httpCode.message)
        } //end: switch
    }//end: else

} //end: apiErrorHandle






// apiReq
// device
export let apiGetDevice = null; //取得device列表  
export let apiGroup = null;  //取得使用者群組 
export let apiGroupDeviceList = null;  //取得使用者群組 
export let apiGroupExecutedData = null;  //取得使用者群組 
export let apiGroupAppointment = null;  //取得使用者群組 
export let apiGetDashboard = null;  //取得device列表
export let apiDeleteGroup = null;  //刪除使用者群組
export let apiGetTasks = null;  //取得Dashboard_Detial
export let apiSettings = null;  //取得device列表
export let apiGroupSpecify = null;  //取得使用者群組
export let apiGetNotifications = null;  //取得Dashboard_Notifications列表
export let apiGetCalibration = null;  //取得Calibration列表
export let apiSetNotification = null;  //接受或刪除Notification
export let apiETTasksList = null;  //[Tasks]取得tasks內容
export let apiSetNotification_delete = null;  //刪除Notification
export let apiSetNotification_approve = null;  //接受Notification
export let apiGetGroupModel = null;  //取得Model和群組
export let apiDeleteGroupDevice = null;  //刪除在群組裡面的裝置
export let apiGroupNameAdd = null;  //新增群組名稱
export let apiGroupNameModify = null;  //變更群組名稱
export let apiAddDevice = null;  //新稱裝置到群組
export let apiDeviceExecutedData = null;  //device et list
export let apiDeviceSetting = null; //device  setting data
export let apiDeleteDevice = null;  //刪除在裝置裡面的裝置
export let apiDeleteTask = null;  //刪除在裝置裡面的裝置
export let apiDeleteAppointment = null;  //刪除在裝置裡面的裝置
export let apiDeviceApp = null;  //刪除在裝置裡面的裝置
export let apiCSV = null;  //匯出裝置csv
export let apiGroupSetting = null;  //設定群組權限
export let apiDeviceProfile = null;  //設定裝置 OSD
export let apiSetTargetList = null;  //設定 Target
export let apiSetAppointments = null;  //設定 Appointments
export let apiSetModify = null;  //設定 Modify
export let apiMe = null; //取得使用者資訊
export let apiDeviceGetProfile = null; //取得使用者資訊
export let apiWsSite = null; //取得Websocket連線位址
export let apiWsFake = null; //取得本地端假資料
export let apiWsModelData = null; //用ssn取得該機台詳細資料
export let apiNotificationsCount = null; //取得訊息總數
export let apiTaskGetEX = null; //取得Task Management executed tasks
export let apiTaskGetAP = null; //取得Task Management appointment
export let apiGetAPDeviceOrGroupID = null; //取得 appointment歸屬於哪個 Device 或者 Group 的 ID
export let apiGetAppointmentTask = null; //取得 appointment 的所有task








// cloud target 
export let apiTargetList = null; //取得target列表
export let apiTargetDel = null; //刪除target
export let apiImportTarget = null; //匯入target
export let apiExportTargets = null; // 匯出targets

// feedback 
export let apiContact = null; //送出contact us

// 邀請碼
export let apiInvitations = null; //產生邀請碼

// add device
export let apiCSVUpload = null; //上傳csv add device
export let apiDeviceAdd = null; //透過ssn add device

// login / logout
export let apiLogin = null; // 登入
export let apiLogout = null; //登出


// privacy 
export let apiAgree = null; // privacy agreement
export let apiWebEvents = null; // web event
export let apiEULA = null; // EULA





export const apiInitSetting = async () => {
    console.log('apiInitSetting')
    // let apiReq = store.state.apiReq;

    // group


    switch (env) {
        case 'mock':  // mock env
            console.log('in mock')
            host = './mock/';
            globalApiReq = axios.create();
            axionInit(globalApiReq, host);
            break;
        case 'dev':  //localhost開發 port:8080
            host = 'https://proart-adc.azurewebsites.net/';
            token = 'Bearer 2|F2zkBXrtXdfdgjUxBo32LMcAJ4WxXwLaJRAtE066';
            globalApiReq = axios.create({
                headers: {
                    "Authorization": token
                },
            });

            axionInit(globalApiReq, host);
            console.log('in dev')
            break;
        case 'dev-online': // 線上RD測試機
        case 'staging':
        case 'adc':
        case 'prod': //staing / prod
            csrfTokenHandle();
            break;

        // host = 'https://proart-web-stage.azurewebsites.net/';
        // csrfTokenHandle(host);
        // // apiReq = axios.create();
        // console.log('staging afte csrfTokenHandle', apiReq);
        // break;

        // host = 'https://proart-web-stage.azurewebsites.net/';
        // csrfTokenHandle(host);
        // console.log('prod afte csrfTokenHandle', apiReq);
        // break;
    }



    switch (env) {
        case 'mock':
            apiGetDevice = () => store.state.apiReq.get('apiGetDevice.json');
            apiGroup = () => store.state.apiReq.get('apiGroup.json');
            apiGroupDeviceList = () => store.state.apiReq.get('apiGroupDeviceList.json');
            apiGroupExecutedData = () => store.state.apiReq.get('apiGroupExecutedData.json');
            apiGroupAppointment = () => store.state.apiReq.get('apiGroupAppointment.json');
            apiGetDashboard = () => store.state.apiReq.get('apiGetDashboard.json');
            // apiGetNotifications = () => store.state.apiReq.get('apiGetNotifications.json'); // join
            // apiGetNotifications = () => store.state.apiReq.get('apiGetNotificationsUnlock.json'); // unlock
            // apiGetNotifications = () => store.state.apiReq.get('apiGetNotificationsUnbind.json'); // unbind
            apiGetNotifications = () => store.state.apiReq.get('apiGetNotificationsOthers.json'); // others
            apiSettings = () => store.state.apiReq.get('apiSettings.json');
            apiDeleteGroup = () => store.state.apiReq.get('apiDeleteGroup.json');
            apiGetCalibration = () => store.state.apiReq.get('apiGetCalibration.json');
            apiGetTasks = () => store.state.apiReq.get('apiGetTasks.json');
            apiSetNotification = () => store.state.apiReq.get('apiSetNotification.json');
            apiETTasksList = () => store.state.apiReq.get('apiETTasksList.json');
            apiSetNotification_delete = () => store.state.apiReq.get('apiSetNotification.json');
            apiSetNotification_approve = () => store.state.apiReq.get('apiSetNotification.json');
            apiGetGroupModel = () => store.state.apiReq.get('apiGetGroupModel.json');
            apiDeleteGroupDevice = () => store.state.apiReq.get('apiDeleteGroupDevice.json');
            apiAddDevice = () => store.state.apiReq.get('apiDeleteGroupDevice.json');
            apiTargetList = () => store.state.apiReq.get('apiTargetList.json');
            apiContact = () => store.state.apiReq.get('apiContact.json');
            apiDeleteTask = () => store.state.apiReq.get('apiContact.json');
            apiDeleteDevice = () => store.state.apiReq.get('apiDeleteDevice.json');
            apiInvitations = () => store.state.apiReq.get('apiInvitations.json');
            apiDeviceApp = () => store.state.apiReq.get('apiDeviceApp.json');
            apiCSV = () => store.state.apiReq.get('apiCSV.json');
            apiGroupSetting = () => store.state.apiReq.get('apiGroupSetting.json');
            apiDeviceSetting = () => store.state.apiReq.get('apiDeviceSetting.json');
            apiDeviceProfile = () => store.state.apiReq.get('apiDeviceProfile.json');
            apiSetTargetList = () => store.state.apiReq.get('apiSetTargetList.json');
            apiSetAppointments = () => store.state.apiReq.get('apiSetTargetList.json');
            apiSetModify = () => store.state.apiReq.get('apiSetTargetList.json');
            apiMe = () => store.state.apiReq.get('apiMe.json');
            apiTargetDel = () => store.state.apiReq.get('apiTargetDel.json');
            apiCSVUpload = () => store.state.apiReq.get('apiCSVUpload.json');
            apiDeviceAdd = () => store.state.apiReq.get('apiDeviceAdd.json');
            apiLogin = () => store.state.apiReq.get('apiLogin.json');
            apiLogout = () => store.state.apiReq.get('apiLogout.json');
            apiWsSite = () => store.state.apiReq.get('apiWs.json');
            apiWsFake = () => store.state.apiReq.get('apiWsFake.json');
            apiWsModelData = () => store.state.apiReq.get('apiWsFake.json');
            apiAgree = () => store.state.apiReq.get('apiAgree.json');
            apiEULA = () => store.state.apiReq.get('apiEULA.json')
            apiWebEvents = () => store.state.apiReq.get('apiWebEvents.json');
            apiDeviceGetProfile = () => store.state.apiReq.get('apiDeviceGetProfile.json');
            apiDeviceExecutedData = () => store.state.apiReq.get('apiDeviceExecutedData.json');
            apiNotificationsCount = () => store.state.apiReq.get('apiNotificationsCount.json');
            apiTaskGetEX = () => store.state.apiReq.get('apiTaskGetEX.json');
            apiTaskGetAP = () => store.state.apiReq.get('apiTaskGetAP.json');
            apiGetAPDeviceOrGroupID = () => store.state.apiReq.get('apiGetAPDeviceOrGroupID.json');
            apiGetAppointmentTask = () => store.state.apiReq.get('apiGetAppointmentTask.json');
            apiExportTargets = () => store.state.apiReq.get('apiExportTargets.json');
            apiImportTarget = (data) => store.state.apiReq.post('apiImportTarget.json', data);

            break;
        case 'dev':
        case 'dev-online':
        case 'prod':
        case 'staging':
        case 'adc':
        default:

            apiCSV = (sendData) => store.state.apiReq.post(csv, sendData)
            apiDeleteAppointment = (sendData) => store.state.apiReq.post(deleteAppointment, sendData)
            apiDeleteTask = (sendData) => store.state.apiReq.post(deleteTask, sendData)
            apiGroupNameAdd = (sendData) => store.state.apiReq.post(group, sendData);
            apiGetDevice = (sendData) => {
                return urlFilter(device, sendData)
            };
            apiWsModelData = (id) => {
                let base = `${device}/${id}`
                return store.state.apiReq.get(base);
            };
            apiGroup = (sendData) => {
                return urlFilter(group, sendData)
            };
            apiGroupDeviceList = (id, sendData) => {
                let base = `${group}/${id}`
                return urlFilter(base, sendData)
            };
            apiGroupExecutedData = (id, sendData) => {
                let base = `${group}/${id}/tasks`
                return urlFilter(base, sendData)
            };
            apiGroupAppointment = (id, sendData) => {
                let base = `${group}/${id}/appointments`
                return urlFilter(base, sendData)
            };
            apiSettings = (sendData) => {
                let base = `${settings}`
                return urlFilter(base, sendData, 'post')
            };
            apiDeleteGroup = (sendData) => store.state.apiReq.post(deleteGroup, sendData);

            apiGetDashboard = (data) => {
                return urlFilter(dashboard, data)
            };
            apiGetNotifications = (data) => {
                return urlFilter(notifications, data)
            };
            apiETTasksList = (id, sendData) => {
                let base = `${tasks}/${id}`
                return urlFilter(base, sendData)
            };
            apiDeleteGroupDevice = (groupID, sendData) => {
                let base = `${group}/${groupID}/delete-devices`
                return store.state.apiReq.post(base, sendData);
            };
            apiGroupNameModify = (groupID, sendData) => {
                let base = `${group}/${groupID}/modify`
                return store.state.apiReq.post(base, sendData);
            };

            apiAddDevice = (groupID, sendData) => {
                let base = `${group}/${groupID}/devices`
                return store.state.apiReq.post(base, sendData);
            };
            apiDeviceExecutedData = (deviceID, sendData) => {
                let base = `${device}/${deviceID}/tasks`
                return urlFilter(base, sendData)
            };
            apiDeleteDevice = (sendData) => {
                return store.state.apiReq.post(deleteDevice, sendData);
            };
            apiDeviceApp = (id, sendData) => {
                let base = `${device}/${id}/appointments`
                return urlFilter(base, sendData)
            };
            apiGroupSetting = (groupID, sendData) => {
                let base = `${group}/${groupID}/permissions`
                return store.state.apiReq.post(base, sendData);
            };
            apiDeviceSetting = (deivceID, sendData) => {
                let base = `${device}/${deivceID}/permissions`
                return store.state.apiReq.post(base, sendData);
            }
            apiDeviceProfile = (deivceID, sendData) => {
                let base = `${device}/${deivceID}/profiles`

                return store.state.apiReq.post(base, sendData);
            }
            apiDeviceGetProfile = (deivceID) => {
                let base = `${device}/${deivceID}/profiles`

                return store.state.apiReq.get(base);
            }
            apiWsSite = () => store.state.apiReq.get(ws);
            apiGetCalibration = (data) => store.state.apiReq.post(calibration, data);
            // apiGetTasks = (id) => store.state.apiReq.get(tasks + '/' + id);
            apiGetTasks = (id, sendData) => {
                let base = `${tasks}/${id}`
                return urlFilter(base, sendData)
            };
            apiTaskGetEX = (sendData, bodyData) => {
                let base = tasks
                return urlFilter(base, sendData, 'get', bodyData)
            };
            apiTaskGetAP = (sendData, bodyData) => {
                let base = appointmentAll
                return urlFilter(base, sendData, 'get', bodyData)
            };
            apiGetAPDeviceOrGroupID = (sendData) => {
                let base = `${appointmentAll}/${sendData}`
                return store.state.apiReq.get(base);
            };
            apiSetNotification = (data) => store.state.apiReq.post(delete_notification, data);
            apiSetNotification_delete = (data) => store.state.apiReq.post(delete_notification, data);
            apiSetNotification_approve = (data) => store.state.apiReq.post(approve_notification, data);
            apiGetGroupModel = () => store.state.apiReq.get(getGroupModel);
            apiTargetList = (model = '', range = -1, sort = '', page = -1, order = 'desc') => {
                // console.log('apiTargetList page', page, 'model', model, 'rage', range);
                console.log(order)
                const _model = model === '' ? '' : `&model=${model}`;
                let _order = `&order=${order}`
                let _range = range == -1 ? '' : `&range=${range}`;
                let _sort = sort === '' ? '' : `&sort=${sort}`;
                let _page = page == -1 ? '' : `&page=${page}`;
                let params = _model + _range + _sort + _page + _order;
                params = params.substring(1);
                return store.state.apiReq.get(`${targets}?${params}`);
            };
            apiSetTargetList = (data) => store.state.apiReq.post(targets, data);
            apiContact = (data) => store.state.apiReq.post(feedback, data);
            apiInvitations = (data) => store.state.apiReq.post(invitations, data);
            apiSetAppointments = (data) => store.state.apiReq.post(appointments, data);
            apiSetModify = (data) => store.state.apiReq.post(modifyAppointments, data);
            apiMe = () => store.state.apiReq.get(me);
            apiTargetDel = (data) => store.state.apiReq.post(delTarget, data);
            apiImportTarget = (data) => store.state.apiReq.post(importTarget, data, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });
            apiExportTargets = (data) => store.state.apiReq.post(exportTarget, data, {
                responseType: 'blob',
            });
            apiCSVUpload = (data) => store.state.apiReq.post(csvs, data);
            apiDeviceAdd = (data) => store.state.apiReq.post(device, data);
            apiLogin = (data) => store.state.apiReq.post(loginURL, data);
            apiLogout = () => store.state.apiReq.get(logoutURL);
            apiAgree = (data) => store.state.apiReq.post(policy, data);
            apiEULA = (data) => store.state.apiReq.post(eula, data)
            apiWebEvents = (data) => store.state.apiReq.post(webEvent, data);
            apiNotificationsCount = () => store.state.apiReq.get(newNotifications);
            // apiGetAppointmentTask = () => store.state.apiReq.get(appointmentTask);
            apiGetAppointmentTask = (sendData, bodyData) => {
                let base = appointmentTask
                return urlFilter(base, sendData, 'get', bodyData)
            };
            break;
    }



} //end: export




const urlFilter = (orgUrl, sendData, method = 'get', bodyData = undefined) => {
    let url = '?'
    for (let e in sendData) {
        if (sendData[e]) {
            url += `${e}=${sendData[e]}&`
        }
    }
    url = url.substring(0, url.length - 1);
    switch (method) {
        case 'post':
            return globalApiReq.post(`${orgUrl}${url}`, bodyData)
        case 'get':
            return globalApiReq.get(`${orgUrl}${url}`, { params: bodyData })
        case 'delete':
            return globalApiReq.delete(`${orgUrl}${url}`, bodyData)
        case 'put':
            return globalApiReq.put(`${orgUrl}${url}`, bodyData)
        case 'patch':
            return globalApiReq.patch(`${orgUrl}${url}`, bodyData)
        default:
            console.log(`未知的 method: ${method}`);
            return false;
    }
    // return apiReq.method(`${orgUrl}${url}`)
}

